export type CartSize = '95 gal ±' | '65 gal ±' | '35 gal ±' | 'other';

export const CART_SIZES: { label: string; value: CartSize }[] = [
  { label: '95 gal ±', value: '95 gal ±' },
  { label: '65 gal ±', value: '65 gal ±' },
  { label: '35 gal ±', value: '35 gal ±' },
  { label: 'Other', value: 'other' },
];
